export const tableOptionColums = [
  { title: "维度", field: "rateFor", minWidth: 150, slots: {} },
  {
    title: "首约及时率",
    field: "timelyAppointmentRate",
    minWidth: 100,
    slots: {},
    params: {
      flag: ["appointmentTimelinessFlag"],
      serviceTypeName: ["安装工单", "维修工单"],
    },
  },
  {
    title: "首约上门准时率",
    field: "onTimeFirstVisitRate",
    minWidth: 100,
    params: {
      flag: ["firstAppointmentPunctualityFlag"],
      serviceTypeName: ["安装工单", "维修工单"],
    },
    slots: {},
  },
  {
    title: "终约及时率",
    field: "finalAppointmentTimelyRate",
    minWidth: 100,
    params: {
      flag: ["finalAppointmentTimelinessFlag"],
      serviceTypeName: ["安装工单", "维修工单"],
    },
    slots: {},
  },
  {
    title: "安装快准率",
    field: "sameDayCompletionRate",
    minWidth: 100,
    params: {
      flag: ["installationSameDayCompletionFlag"],
      serviceTypeName: ["安装工单"],
    },
    slots: {},
  },
  {
    title: "3天内维修完结率",
    field: "repairWithinThreeDaysRate",
    minWidth: 100,
    params: {
      flag: ["threeDayRepairCompletionFlag"],
      serviceTypeName: ["维修工单"],
    },
    slots: {},
  },
  {
    title: "5天内维修完结率",
    field: "repairWithinFiveDaysRate",
    minWidth: 100,
    params: {
      flag: ["fiveDayRepairCompletionFlag"],
      serviceTypeName: ["维修工单"],
    },
    slots: {},
  },
  {
    title: "APP完工率",
    field: "appCompletionRate",
    minWidth: 100,
    params: {
      flag: ["appCompletionRateFlag"],
      serviceTypeName: ["安装工单", "维修工单"],
    },
    slots: {},
  },
  {
    title: "不满意工单占比",
    field: "unsatisfiedOrderRate",
    minWidth: 100,
    params: {
      flag: ["dissatisfactionRateFlag"],
      serviceTypeName: ["安装工单", "维修工单"],
    },
    slots: {},
  },
  {
    title: "京东安装差评率",
    field: "jdInstallationNegativeReviewRate",
    minWidth: 100,
    params: {
      flag: ["jdInstallBadRateFlag"],
      serviceTypeName: ["安装工单"],
    },
    slots: {},
  },
  {
    title: "京东售后满意度",
    field: "jdAfterSalesSatisfactionRate",
    minWidth: 100,
    params: {
      flag: ["jdAfterSalesSatisfactionFlag"],
      serviceTypeName: ["维修工单"],
    },
    slots: {},
  },
];
// 设置单元格格式和事件
export function createRateSlot(tableData, h, handleCellClick) {
  // 添加鼠标事件处理函数
  const handleMouseEnter = (event) => {
    event.target.style.color = "#409EFF";
    event.target.style.textDecoration = "underline";
    event.target.style.cursor = "pointer";
  };

  const handleMouseLeave = (event) => {
    event.target.style.color = "";
    event.target.style.textDecoration = "";
  };

  // 处理指标显示样式
  return function formatterRateSlot({ row, rowIndex, column }) {
    const field = column.property;
    const currentValue = row[field];
    let size = tableData.records.length;
    var showValue = "";
    var onEvent = {
      click: () => handleCellClick({ row, rowIndex, column }),
      mouseenter: handleMouseEnter,
      mouseleave: handleMouseLeave,
    };
    // 维度那一列直接显示值，其他具体指标值按百分比显示，最后一行不添加事件
    if (field === "rateFor") {
      showValue = currentValue;
      if (rowIndex === size - 1) {
        onEvent = {};
      }
    } else {
      showValue = (parseFloat(currentValue) * 100).toFixed(2) + "%";
    }

    // 创建带鼠标事件的span元素
    const spanElement = h(
      "span",
      {
        on: onEvent,
        style: {
          transition: "all 0.3s",
        },
      },
      showValue
    );
    if (rowIndex === 1 && field != "rateFor") {
      const prevRow = tableData.records[0];
      const previousValue = prevRow[field] ? prevRow[field] : 0;

      if (currentValue > previousValue) {
        return [
          spanElement,
          h("i", {
            class: "el-icon-caret-top",
            style: { color: "red", marginLeft: "5px", fontSize: "16px" },
          }),
        ];
      } else if (currentValue < previousValue) {
        return [
          spanElement,
          h("i", {
            class: "el-icon-caret-bottom",
            style: { color: "green", marginLeft: "5px", fontSize: "16px" },
          }),
        ];
      }
    }

    if (rowIndex === size - 1 && field != "rateFor") {
      const currentRow = tableData.records[size - 3];
      const currentRowValue = currentRow[field] ? currentRow[field] : 0;
      const top1Row = tableData.records[size - 2];
      const top1Value = top1Row[field] ? top1Row[field] : 0;
      return (parseFloat(currentRowValue - top1Value) * 100).toFixed(2) + "%";
    }
    return [spanElement];
  };
}

export const rankTableOptionColums = [
  { title: "服务经理", field: "userName", width: "25%" },
  { title: "月份", field: "month", width: "25%" },
  { title: "得分", field: "score", width: "25%" },
  { title: "排名", field: "rankNo", width: "25%" },
];

export const rankAltTableOptionColums = [
  { title: "服务商", field: "userName", width: "33.3%" },
  { title: "服务经理", field: "managerUserName", width: "16.7%" },
  { title: "月份", field: "month", width: "12.5%" },
  { title: "赛区", field: "region", width: "12.5%" },
  { title: "得分", field: "score", width: "12.5%" },
  { title: "排名", field: "rankNo", width: "12.5%" },
];

export const engineerRankTableOptionColums = [
  { title: "一级服务商名称", field: "bigSiteName", width: "20%" },
  { title: "二级服务商名称", field: "siteName", width: "20%" },
  { title: "工程师名称", field: "engineerName", width: "20%" },
  { title: "工程师工号", field: "engineerCode", width: "20%"},
  { title: "月份", field: "month", width: "20%"},
  { title: "得分", field: "score", width: "20%" },
  { title: "排名", field: "rankNo", width: "20%" },
];

export const allEngineerRankTableOptionColums = [
  { title: "一级服务商名称", field: "bigSiteName", width: "20%" },
  { title: "二级服务商名称", field: "siteName", width: "20%" },
  { title: "工程师名称", field: "engineerName", width: "20%" },
  { title: "工程师工号", field: "engineerCode", width: "20%"},
  { title: "月份", field: "month", width: "20%"},
  { title: "得分", field: "score", width: "20%" },
  { title: "排名", field: "rankNo", width: "20%" },
];

export const tableOption = {
  resizable: true,
  showOverflow: true,
  height: "100%",
  fit: true,
  rowId: "id",
  printConfig: {},
  sortConfig: {
    trigger: "cell",
    remote: true,
    defaultSort: {},
  },
  filterConfig: {
    remote: true,
  },
  // pagerConfig: {
  //   pageSize: 100,
  //   pageSizes: [100, 200, 500, 1000],
  // },
  exportConfig: {
    // 默认选中类型
    type: "xlsx",
    // 局部自定义类型
    types: ["xlsx", "csv", "html", "xml", "txt"],
    // 自定义数据量列表
    modes: ["current", "all"],
  },
  radioConfig: {
    labelField: "id",
    reserve: true,
    highlight: true,
  },
  checkboxConfig: {
    checkStrictly: true,
    showHeader: true,
    trigger: "row",
    // labelField: 'id',
    reserve: true,
  },
  rowConfig: {
    keyField: "id",
  },
  columns: {},
};
